<template>
    <div class="row">
        <div class="col-md-12" style="margin: -15px;">
            <div class="card card-sm">
                <!-- HEADER con filtros -->
                <div class="card-header" style="background-color: #DBECDB;">
                    <div class="card-title row">
                        <!-- Título -->
                        <div class="col-md-12 mb-2">
                            <h4 class="mb-0">Reporte de Tickets</h4>
                        </div>
                    </div>

                    <!-- Fila 1: Filtros principales -->
                    <div class="row mb-2">
                        <div class="col-md-3">
                            <div class="input-group">
                                <label class="form-label">Ventanilla:</label>
                                <select 
                                    v-model="filters.ventanilla" 
                                    class="form-select"
                                >
                                    <option value="">Todas</option>
                                    <option 
                                        v-for="item in selectores.ventanillas" 
                                        :key="item.id" 
                                        :value="item.id"
                                    >
                                        {{ item.codigo }} - {{ item.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="input-group">
                                <label class="form-label">Trámite:</label>
                                <select 
                                    v-model="filters.tipo_tramite" 
                                    class="form-select"
                                >
                                    <option value="">Todos</option>
                                    <option 
                                        v-for="item in selectores.tipos_tramite" 
                                        :key="item.id" 
                                        :value="item.id"
                                    >
                                        {{ item.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="input-group">
                                <label class="form-label">Preferencia:</label>
                                <select 
                                    v-model="filters.preferencia" 
                                    class="form-select"
                                >
                                    <option value="">Todas</option>
                                    <option 
                                        v-for="item in selectores.preferencias" 
                                        :key="item.id" 
                                        :value="item.id"
                                    >
                                        {{ item.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3">
                            <div class="input-group">
                                <label class="form-label">Estado:</label>
                                <select 
                                    v-model="filters.estado" 
                                    class="form-select"
                                >
                                    <option value="">Todos</option>
                                    <option 
                                        v-for="item in selectores.estados" 
                                        :key="item.valor" 
                                        :value="item.valor"
                                    >
                                        {{ item.texto }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <!-- Fila 2: Fechas -->
                    <div class="row mb-2">
                        <div class="col-md-3">
                            <div class="input-group">
                                <label class="form-label">Período:</label>
                                <select 
                                    v-model="filters.tipo_fecha" 
                                    class="form-select"
                                    @change="handleTipoFechaChange"
                                >
                                    <option value="rango">Rango</option>
                                    <option value="dia">Día</option>
                                    <option value="mes">Mes</option>
                                    <option value="anual">Anual</option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3" v-if="filters.tipo_fecha === 'dia'">
                            <div class="input-group">
                                <label class="form-label">Fecha:</label>
                                <input
                                    type="date"
                                    v-model="filters.fecha"
                                    class="form-control"
                                />
                            </div>
                        </div>

                        <div class="col-md-3" v-if="filters.tipo_fecha === 'mes'">
                            <div class="input-group">
                                <label class="form-label">Mes:</label>
                                <select v-model="filters.mes" class="form-select">
                                    <option v-for="mes in meses" :key="mes.valor" :value="mes.valor">
                                        {{ mes.nombre }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3" v-if="filters.tipo_fecha === 'mes' || filters.tipo_fecha === 'anual'">
                            <div class="input-group">
                                <label class="form-label">Gestión:</label>
                                <select 
                                    v-model="filters.gestion" 
                                    class="form-select"
                                >
                                    <option v-for="year in gestiones" :key="year" :value="year">
                                        {{ year }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-3" v-if="filters.tipo_fecha === 'rango'">
                            <div class="input-group">
                                <label class="form-label">Desde:</label>
                                <input
                                    type="date"
                                    v-model="filters.desde"
                                    class="form-control"
                                />
                            </div>
                        </div>

                        <div class="col-md-3" v-if="filters.tipo_fecha === 'rango'">
                            <div class="input-group">
                                <label class="form-label">Hasta:</label>
                                <input
                                    type="date"
                                    v-model="filters.hasta"
                                    class="form-control"
                                />
                            </div>
                        </div>

                        <div class="col-md-3 d-flex align-items-center">
                            <BButton 
                                class="btn btn-sm btn-secondary me-2" 
                                @click="handleSearch"
                            >
                                <i class="fa fa-search"></i> Buscar
                            </BButton>
                            <BButton
                                variant="danger"
                                class="btn btn-sm"
                                @click="generatePDF"
                            >
                                <i class="fa fa-file-pdf me-1"></i> PDF
                            </BButton>
                        </div>
                    </div>
                </div>

                <div class="card-body pt-1">
                    <!-- Resumen -->
                    <div class="row mb-3" v-if="!loading && resumen.total_tickets > 0">
                        <div class="col-md-2">
                            <div class="card bg-primary text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">Total Tickets</h6>
                                    <h5 class="mb-0">{{ resumen.total_tickets }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="card bg-success text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">Atendidos</h6>
                                    <h5 class="mb-0">{{ resumen.atendidos }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="card bg-warning text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">En espera</h6>
                                    <h5 class="mb-0">{{ resumen.en_espera }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="card bg-info text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">Llamados</h6>
                                    <h5 class="mb-0">{{ resumen.llamados || 0 }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="card bg-danger text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">Cancelados</h6>
                                    <h5 class="mb-0">{{ resumen.cancelados || 0 }}</h5>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="card bg-secondary text-white">
                                <div class="card-body py-2">
                                    <h6 class="card-title">Rango Fechas</h6>
                                    <h6 style="font-size:0.7rem" class="mb-0">{{ rangoFechas }}</h6>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Loading -->
                    <div v-if="loading" class="text-center py-4">
                        <div class="spinner-border text-primary" role="status">
                            <span class="sr-only">Cargando...</span>
                        </div>
                        <p class="mt-2">Generando reporte...</p>
                    </div>

                    <!-- Tabla -->
                    <div v-else>
                        <div class="table-responsive">
                            <table class="table table-sm table-striped table-hover table-bordered" style="font-size: 0.8rem;">
                                <thead class="text-primary">
                                    <tr>
                                        <th>#</th>
                                        <th>N° Ticket</th>
                                        <th>Trámite</th>
                                        <th>Preferencia</th>
                                        <th>Estado</th>
                                        <th>Fecha Solicitud</th>
                                        <th>Fecha Llamado</th>
                                        <th>Tiempo Espera</th>
                                        <th>Tiempo Atención</th>
                                        <th>Usuario</th>
                                        <th>Documento</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in items" :key="item.id || index">
                                        <td class="text-center">{{ index + 1 }}</td>
                                        <td><strong>{{ item.numero_ticket }}</strong></td>
                                        <td>{{ item.tipo_tramite }}</td>
                                        <td>{{ item.preferencia }}</td>
                                        <td>
                                            <span :class="'badge bg-' + item.estado_color">
                                                {{ item.estado_texto }}
                                            </span>
                                        </td>
                                        <td class="text-center">{{ item.fecha_solicitud }}</td>
                                        <td class="text-center">{{ item.fecha_llamado || '-' }}</td>
                                        <td class="text-center">{{ item.tiempo_espera || '-' }}</td>
                                        <td class="text-center">{{ item.tiempo_atencion || '-' }}</td>
                                        <td>{{ item.usuario || '-' }}</td>
                                        <td>{{ item.documento || '-' }}</td>
                                    </tr>
                                    <tr v-if="items.length === 0">
                                        <td :colspan="11" class="text-center py-4">
                                            No hay datos con los filtros seleccionados
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- Paginación -->
                        <div class="row mt-3" v-if="pagination.total > 0">
                            <div class="col-md-6">
                                <p class="text-muted">
                                    Mostrando {{ pagination.from }} - {{ pagination.to }} de {{ pagination.total }} registros
                                </p>
                            </div>
                            <div class="col-md-6">
                                <BPagination
                                    v-model="pagination.current_page"
                                    :total-rows="pagination.total"
                                    :per-page="pagination.per_page"
                                    @page-click="handlePageClick"
                                    align="right"
                                    size="sm"
                                ></BPagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton, BPagination } from 'bootstrap-vue-3';

export default {
    name: 'ReporteTicket',
    components: {
        BButton,
        BPagination
    },
    setup() {
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

        // ===== FILTROS =====
        const filters = reactive({
            ventanilla: '',
            tipo_tramite: '',
            preferencia: '',
            estado: '',
            tipo_fecha: 'rango',
            fecha: today.toISOString().split('T')[0],
            mes: today.getMonth() + 1,
            gestion: today.getFullYear(),
            desde: firstDay.toISOString().split('T')[0],
            hasta: today.toISOString().split('T')[0]
        });

        // ===== DATOS =====
        const items = ref([]);
        const loading = ref(false);
        const selectores = ref({
            ventanillas: [],
            tipos_tramite: [],
            preferencias: [],
            estados: []
        });

        // ===== PAGINACIÓN =====
        const pagination = reactive({
            current_page: 1,
            per_page: 15,
            total: 0,
            last_page: 1,
            from: 0,
            to: 0
        });

        // ===== RESUMEN =====
        const resumen = reactive({
            total_tickets: 0,
            atendidos: 0,
            en_espera: 0,
            llamados: 0,
            cancelados: 0,
            reprogramados: 0
        });

        // ===== COMPUTADAS =====
        const gestiones = computed(() => {
            const year = today.getFullYear();
            return [year - 2, year - 1, year, year + 1];
        });

        const meses = [
            { valor: 1, nombre: 'Enero' },
            { valor: 2, nombre: 'Febrero' },
            { valor: 3, nombre: 'Marzo' },
            { valor: 4, nombre: 'Abril' },
            { valor: 5, nombre: 'Mayo' },
            { valor: 6, nombre: 'Junio' },
            { valor: 7, nombre: 'Julio' },
            { valor: 8, nombre: 'Agosto' },
            { valor: 9, nombre: 'Septiembre' },
            { valor: 10, nombre: 'Octubre' },
            { valor: 11, nombre: 'Noviembre' },
            { valor: 12, nombre: 'Diciembre' }
        ];

        const rangoFechas = computed(() => {
            if (filters.tipo_fecha === 'dia' && filters.fecha) {
                return formatDate(filters.fecha);
            } else if (filters.tipo_fecha === 'mes' && filters.mes) {
                const mes = meses.find(m => m.valor === parseInt(filters.mes))?.nombre || filters.mes;
                return `${mes} ${filters.gestion}`;
            } else if (filters.tipo_fecha === 'anual') {
                return `Gestión ${filters.gestion}`;
            } else if (filters.desde && filters.hasta) {
                return `${formatDate(filters.desde)} - ${formatDate(filters.hasta)}`;
            }
            return 'Todos los períodos';
        });

        // ===== MÉTODOS =====
        const formatDate = (date) => {
            if (!date) return '';
            try {
                const dateObj = new Date(date);
                if (isNaN(dateObj.getTime())) return '';
                return dateObj.toLocaleDateString('es-ES', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            } catch {
                return '';
            }
        };

        const handleTipoFechaChange = () => {
            // Resetear valores según tipo
            if (filters.tipo_fecha === 'dia') {
                filters.fecha = today.toISOString().split('T')[0];
                filters.mes = null;
                filters.desde = '';
                filters.hasta = '';
            } else if (filters.tipo_fecha === 'mes') {
                filters.mes = today.getMonth() + 1;
                filters.fecha = '';
                filters.desde = '';
                filters.hasta = '';
            } else if (filters.tipo_fecha === 'anual') {
                filters.gestion = today.getFullYear();
                filters.fecha = '';
                filters.mes = null;
                filters.desde = '';
                filters.hasta = '';
            } else {
                filters.desde = firstDay.toISOString().split('T')[0];
                filters.hasta = today.toISOString().split('T')[0];
                filters.fecha = '';
                filters.mes = null;
            }
        };

        // ===== CARGAR SELECTORES =====
        const loadSelectores = async () => {
            try {
                const response = await axios.get('/reporte-tickets/selectores');
                if (response.data.success) {
                    selectores.value = response.data.data;
                }
            } catch (error) {
                console.error('Error al cargar selectores:', error);
            }
        };

        // ===== CARGAR DATOS =====
        const fetchData = async () => {
            loading.value = true;

            try {
                const params = {
                    page: pagination.current_page,
                    per_page: pagination.per_page
                };

                // Agregar filtros
                Object.keys(filters).forEach(key => {
                    if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                        params[key] = filters[key];
                    }
                });

                const response = await axios.get('/reporte-tickets/datos', { params });

                if (response.data.success) {
                    const data = response.data.data;

                    items.value = data.datos || [];

                    // Paginación
                    pagination.current_page = data.current_page;
                    pagination.per_page = data.per_page;
                    pagination.total = data.total;
                    pagination.last_page = data.last_page;
                    pagination.from = data.from;
                    pagination.to = data.to;

                    // Resumen
                    if (data.resumen) {
                        resumen.total_tickets = data.resumen.total_tickets || 0;
                        resumen.atendidos = data.resumen.atendidos || 0;
                        resumen.en_espera = data.resumen.en_espera || 0;
                        resumen.llamados = data.resumen.llamados || 0;
                        resumen.cancelados = data.resumen.cancelados || 0;
                        resumen.reprogramados = data.resumen.reprogramados || 0;
                    }
                }
            } catch (error) {
                console.error('Error al cargar datos:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudieron cargar los datos'
                });
            } finally {
                loading.value = false;
            }
        };

        // ===== HANDLERS =====
        const handleSearch = () => {
            pagination.current_page = 1;
            fetchData();
        };

        const handlePageClick = (event, page) => {
            event.preventDefault();
            pagination.current_page = page;
            fetchData();
        };

        // ===== GENERAR PDF =====
        const generatePDF = async () => {
            try {
                const params = {};

                Object.keys(filters).forEach(key => {
                    if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
                        params[key] = filters[key];
                    }
                });

                Swal.fire({
                    title: 'Generando PDF',
                    text: 'Por favor espere...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const response = await axios.get('/reporte-tickets/exportar-pdf', {
                    params,
                    responseType: 'blob'
                });

                Swal.close();

                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `reporte-tickets-${new Date().toISOString().split('T')[0]}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo generar el PDF'
                });
            }
        };

        // ===== INIT =====
        onMounted(() => {
            loadSelectores();
            fetchData();
        });

        return {
            filters,
            items,
            loading,
            selectores,
            pagination,
            resumen,
            gestiones,
            meses,
            rangoFechas,
            handleTipoFechaChange,
            handleSearch,
            handlePageClick,
            generatePDF,
            formatDate
        };
    }
};
</script>

<style scoped>
thead th {
    background-color: #D84315;
    color: #ffffff;
    position: sticky;
    top: 0;
    z-index: 10;
    font-size: 0.75rem;
    white-space: nowrap;
}

tbody td {
    padding: 6px !important;
    vertical-align: middle;
}

.table-responsive {
    max-height: 500px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
    border-radius: 4px;
}

.card-header .input-group {
    align-items: center;
    gap: 5px;
}

.card-header label {
    min-width: 60px;
    margin-bottom: 0;
    font-weight: 500;
    font-size: 0.8rem;
}

.card-header select,
.card-header input {
    font-size: 0.8rem;
}

.bg-primary { background: #667eea !important; }
.bg-success { background: #43e97b !important; }
.bg-warning { background: #fa709a !important; }
.bg-info { background: #4facfe !important; }
.bg-danger { background: #e74c3c !important; }
.bg-secondary { background: #6c757d !important; }

.card-body {
    padding: 0.75rem;
}

.card-title {
    margin-bottom: 0.25rem;
    font-size: 0.75rem;
}

h4, h6 {
    margin: 0;
}

.text-white-50 {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 0.7rem;
}
</style>